import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { colors, fontMono, formatUtcTime, s } from "../lib/theme";

export default function QslSearch() {
  const { activityId } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [callsign, setCallsign] = useState("");
  const [result, setResult] = useState(null);
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    api.publicQslInfo(activityId).then(setInfo).catch((err) => setError(err.message));
  }, [activityId]);

  const search = async (e) => {
    e.preventDefault();
    if (!callsign.trim()) return;
    setSearching(true);
    setError(null);
    setResult(null);
    try {
      const data = await api.publicQslSearch(activityId, callsign.trim());
      setResult(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setSearching(false);
    }
  };

  if (error && !info) {
    return (
      <div style={{ ...s.page, maxWidth: 640 }}>
        <div style={s.errorBox}>{error}</div>
        <Link to={`/directo/${activityId}`} style={{ color: colors.amber }}>← Volver a la actividad</Link>
      </div>
    );
  }

  return (
    <div style={{ ...s.page, maxWidth: 640 }}>
      <Link to={`/directo/${activityId}`} style={{ color: colors.textDim, fontSize: 14, fontWeight: 700, textDecoration: "none" }}>← Volver a la actividad</Link>
      <h1 style={s.h1}>Descarga tu QSL</h1>
      {info && <p style={s.subtitle}>{info.name} — escribe tu indicativo para ver tus contactos.</p>}

      {info?.templateUrl && !result && (
        <img src={info.templateUrl} alt="Plantilla de QSL" style={{ maxWidth: "100%", borderRadius: 10, border: `1px solid ${colors.line}`, marginTop: 18 }} />
      )}

      <form onSubmit={search} style={{ ...s.card, display: "flex", gap: 12, marginTop: 20, alignItems: "flex-end" }}>
        <div style={{ flex: 1 }}>
          <label style={s.label}>TU INDICATIVO</label>
          <input
            style={{ ...s.input, textTransform: "uppercase", fontSize: 16 }}
            value={callsign}
            onChange={(e) => setCallsign(e.target.value.toUpperCase())}
            placeholder="EA5NEW"
            autoFocus
          />
        </div>
        <button type="submit" disabled={searching || !callsign.trim()} style={{ ...s.btnPrimary, opacity: searching ? 0.6 : 1 }}>
          {searching ? "Buscando…" : "Buscar"}
        </button>
      </form>

      {error && <div style={{ ...s.errorBox, marginTop: 16 }}>{error}</div>}

      {result && !result.found && (
        <p style={{ marginTop: 20, color: colors.textDim }}>No hemos encontrado ningún contacto con <b>{callsign}</b> en esta actividad.</p>
      )}

      {result?.found && result.mode === "summary" && (
        <div style={{ ...s.card, marginTop: 20, textAlign: "center" }}>
          <p style={{ fontSize: 14, color: colors.text, marginBottom: 4 }}>
            <b>{result.callsign}</b> — {result.totalContacts} contacto{result.totalContacts === 1 ? "" : "s"}
            {result.totalPoints != null && <> · {result.totalPoints} puntos</>}
          </p>
          <a
            href={api.qslSummaryImageUrl(activityId, result.callsign)}
            download={`QSL_${result.callsign}.jpg`}
            style={{ ...s.btnPrimary, display: "inline-flex", textDecoration: "none", marginTop: 12 }}
          >
            Descargar mi diploma
          </a>
        </div>
      )}

      {result?.found && result.mode === "per_contact" && (
        <div style={{ marginTop: 20 }}>
          <p style={{ fontSize: 13, color: colors.textFaint, marginBottom: 10 }}>
            {result.contacts.length} contacto{result.contacts.length === 1 ? "" : "s"} de <b style={{ color: colors.text }}>{result.callsign}</b> en esta actividad:
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {result.contacts.map((c) => (
              <div key={c.id} style={{ ...s.card, display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px" }}>
                <span style={{ fontFamily: fontMono, fontSize: 13, color: colors.textDim }}>
                  {c.band} · {c.mode} · {formatUtcTime(c.loggedAt)}
                </span>
                <a href={api.qslContactImageUrl(activityId, c.id)} download={`QSL_${result.callsign}_${c.band}_${c.mode}.jpg`} style={{ ...s.btnGhost, textDecoration: "none" }}>
                  Descargar
                </a>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
